import React, { Fragment, useState, useEffect, useContext } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import { fetchAllUsers } from '../../../api/user';
import AdminContext from '../../../_helper/Admin';
import UserRVOPVStats from './UserRVOPVStats';
import UserRVOPVTable from './UserRVOPVTable';
import UserRVOPVChart from './UserRVOPVChart';
import UserRVOPVDistribution from './UserRVOPVDistribution';
import UserRVOPVActivities from './UserRVOPVActivities';

const Ecommerce = () => {
  const [usersRVOPV, setUsersRVOPV] = useState([]);
  const [loading, setLoading] = useState(true);
  const { isAuthenticated, status } = useContext(AdminContext);

  const loadData = async () => {
    if (!isAuthenticated || status !== 'LOGGED_IN') {
      setUsersRVOPV([]);
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const response = await fetchAllUsers();
      const users = Array.isArray(response) ? response : response?.data || [];
      setUsersRVOPV(users);
    } catch (error) {
      console.error('Error loading users RVOPV:', error);
      setUsersRVOPV([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, [isAuthenticated, status]);

  return (
    <Fragment>
      <Breadcrumbs mainTitle='Quản Lý User RVOPV' parent='Dashboard' title='User RVOPV' />
      <Container fluid={true}>
        <Row>
          <UserRVOPVStats usersRVOPV={usersRVOPV} loading={loading} />
          <UserRVOPVChart usersRVOPV={usersRVOPV} loading={loading} />
          <UserRVOPVDistribution usersRVOPV={usersRVOPV} loading={loading} />
          <UserRVOPVActivities usersRVOPV={usersRVOPV} loading={loading} />
          <UserRVOPVTable usersRVOPV={usersRVOPV} loading={loading} onRefresh={loadData} />
        </Row>
      </Container>
    </Fragment>
  );
};

export default Ecommerce;
